var map = {
	".": "yse3",
	"./": "yse3",
	"./01_get_user_balance": "W4Cx",
	"./01_get_user_balance.json": "W4Cx",
	"./02_get_user_positions": "mp7j",
	"./02_get_user_positions.json": "mp7j",
	"./03_get_user_income": "h0vl",
	"./03_get_user_income.json": "h0vl",
	"./18_get_trade_income_export": "/Pe4",
	"./18_get_trade_income_export.json": "/Pe4",
	"./19_get_trade_user_commissionRate": "v5LS",
	"./19_get_trade_user_commissionRate.json": "v5LS",
	"./index": "yse3",
	"./index.js": "yse3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2yBk";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/api/account ^.*$
// module id = 2yBk
// module chunks = 3